<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/payment-records'" :columns="columns" :filters="filters" :formFields="formFields" title="支付记录" />
    </div>
  </div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
export default { name: 'PaymentRecordsList', components: { Sidebar, AdminTable },
  data() { return {
    columns: [{ key: 'id', label: 'ID' }, { key: 'user_id', label: '用户ID' }, { key: 'amount', label: '金额' }, { key: 'payment_type', label: '类型' }, { key: 'status', label: '状态', type: 'tag', options: { pending: '待支付', success: '成功', failed: '失败' } }, { key: 'created_at', label: '时间', type: 'date' }],
    filters: [], formFields: [{ key: 'user_id', label: '用户ID', type: 'number', required: true }, { key: 'amount', label: '金额', type: 'number', required: true }, { key: 'payment_type', label: '类型', type: 'text', required: true }, { key: 'status', label: '状态', type: 'select', options: [{ value: 'pending', label: '待支付' }, { value: 'success', label: '成功' }, { value: 'failed', label: '失败' }] }]
  } }
}
</script>
<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
</style>
